import {hideError, showError} from "../actions/actions";
import axios from "axios";
import {API_URL} from "../config";
import {GET_NOTIFICATION_ERROR} from "../types/types";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {
    GET_AUDIO_CONTROL,
    GET_AUDIO_CONTROL_PAGINATION,
    GET_AUDIO_CONTROLS,
    SHOW_AUDIO_CONTROL_DETAIL_LOADING,
    SHOW_AUDIO_CONTROL_SAVE_LOADER,
} from "../types/typesAudioControlList";
import {setAudioControlErrorField, showAudioControlLoader} from "../actions/actionsAudioControl";
import {
    serializeAudioControlDataToApi,
    type AudioControlData,
} from "../../components/Settings/AudioControlList/audioControlQuestionnaire";

let dataSort = {
    isArchived: false,
    pageNumber: 1,
    pageSize: 10,
    sort: {
        orderBy: "Id",
        isDesc: true
    }
}

export function getAllAudioControlsWithPagination(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showAudioControlLoader(true))
        dispatch(hideError())
        axios.post(`${API_URL}QualityControl/GetAllControlsWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dataSort = data;
                dispatch({type: GET_AUDIO_CONTROLS, payload: response.data.data.items})
                dispatch({type: GET_AUDIO_CONTROL_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAudioControlLoader(false));
                dispatch(hideError());
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function getAudioControlById(id: number, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SHOW_AUDIO_CONTROL_DETAIL_LOADING, payload: true});
        dispatch(hideError());
        axios.get(`${API_URL}QualityControl/GetControlById?controlId=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({
                    type: GET_AUDIO_CONTROL,
                    payload: response.data.data,
                });
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SHOW_AUDIO_CONTROL_DETAIL_LOADING, payload: false});
            })
    }
}

export function createAudioControl(data: AudioControlData, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setAudioControlErrorField(null));
        dispatch(hideError());
        dispatch({type: SHOW_AUDIO_CONTROL_SAVE_LOADER, payload: true});
        const {id, ...payload} = serializeAudioControlDataToApi(data);
        axios.post(`${API_URL}QualityControl/CreateControl`, payload, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO_CONTROL, payload: response.data.data});
                    dispatch(getAllAudioControlsWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400) {
                    dispatch(setAudioControlErrorField({
                        nameUniq: "Назва вже існує",
                    }));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SHOW_AUDIO_CONTROL_SAVE_LOADER, payload: false});
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function updateAudioControl(data: AudioControlData, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(setAudioControlErrorField(null));
        dispatch(hideError());
        dispatch({type: SHOW_AUDIO_CONTROL_SAVE_LOADER, payload: true});
        const payload = serializeAudioControlDataToApi(data);
        axios.put(`${API_URL}QualityControl/UpdateControl`, payload, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO_CONTROL, payload: response.data.data});
                    dispatch(getAllAudioControlsWithPagination(dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
                if (response.data.statusCode === 400) {
                    dispatch(setAudioControlErrorField({
                        nameUniq: "Назва вже існує",
                    }));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch({type: SHOW_AUDIO_CONTROL_SAVE_LOADER, payload: false});
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
                dispatch(showAccessDeniedNotifications(false));
            })
    }
}

export function copyAudioControlById(id: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        axios.get(`${API_URL}QualityControl/CopyControl/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: GET_AUDIO_CONTROL, payload: response.data.data});
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllAudioControlsWithPagination(sort || dataSort, jwtToken));
                } else {
                    dispatch(getAllAudioControlsWithPagination(sort || dataSort, jwtToken));
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(showError())
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function archiveOrUnArchiveAudioControlById(id: number, jwtToken: any, sort?: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}QualityControl/ArchiveOrUnArchiveControl?controlId=${id}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                    dispatch(getAllAudioControlsWithPagination(sort || dataSort, jwtToken));
                } else {
                    dispatch({type: SET_USER_STATUS_ERROR, payload: {message: response.data.message}})
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function fetchSimpleUsersControls(jwtToken: string) {
    return axios.get(`${API_URL}QualityControl/GetSimpleUsersControls`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function fetchAudioControlById(controlId: number, jwtToken: string) {
    return axios.get(`${API_URL}QualityControl/GetControlById?controlId=${controlId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

